import { siteConfig } from "../../config/end-points";
import "./footer.css";

export const Footer = () => {
  return (
    <footer id="footer">
      <div className="container">
        {siteConfig.copyright} &nbsp;&nbsp;
      </div>
    </footer>
  );
};
